import ReservationDueDateList from "../containers/reservations/cruise/reservationDueDate/ReservationDueDateList";
const routes = [
  {
    path: "/reservationDueDate",
    component: ReservationDueDateList,
  },
];

export { routes as reservationDueDateRoutes };
